<template>
	<v-dialog :value="value" max-width="560" persistent @input="$emit('input', $event)">
		<v-card v-if="row">
			<v-card-title class="text-h6">Applica prezzo</v-card-title>
			<v-card-subtitle class="pt-1">{{ row.name }}<span v-if="row.sku || row.variantSku" class="grey--text"> · {{ row.sku || row.variantSku }}</span></v-card-subtitle>
			<v-card-text>
				<v-simple-table dense class="mb-4">
					<tbody>
						<tr>
							<td>Concorrente più economico</td>
							<td class="text-right font-weight-bold">{{ money(minimo) }}</td>
						</tr>
						<tr>
							<td>Prezzo attuale (IVA inclusa)</td>
							<td class="text-right" :class="{ 'red--text font-weight-bold': row.status === 'beaten', 'green--text text--darken-2 font-weight-bold': row.status === 'winning' }">
								{{ money(row.price) }}
							</td>
						</tr>
						<tr>
							<td>Nuovo prezzo (IVA inclusa)</td>
							<td class="text-right font-weight-bold">{{ valido ? money(Number(price)) : '—' }}</td>
						</tr>
						<tr>
							<td>Nuovo prezzo netto (IVA {{ vat }}%)</td>
							<td class="text-right">{{ valido ? money(netto) : '—' }}</td>
						</tr>
					</tbody>
				</v-simple-table>

				<v-text-field
					v-model="price"
					label="Nuovo prezzo IVA inclusa"
					type="number"
					step="0.01"
					min="0.01"
					suffix="€"
					outlined
					dense
					hide-details="auto"
					:rules="[regole.positivo]"
					hint="Proposto: un centesimo sotto il concorrente più economico. Puoi modificarlo."
					persistent-hint
				></v-text-field>

				<v-alert type="info" text dense class="mt-4 mb-0">Aggiorna il prezzo del catalogo (sito e Shopify). Le inserzioni Amazon/eBay non vengono modificate.</v-alert>
				<v-alert v-if="error" type="error" text dense class="mt-2 mb-0">{{ error }}</v-alert>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text :disabled="saving" @click="$emit('input', false)">Annulla</v-btn>
				<v-btn color="primary" depressed :loading="saving" :disabled="!valido" @click="conferma">Conferma</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { minCompetitor, netPrice, round2, money } from '../../views/competitor/pricing';

// Conferma del nuovo prezzo di catalogo: il salvataggio lo fa il contenitore, qui solo il valore.
export default {
	name: 'CompetitorApplyPriceDialog',
	props: {
		value: { type: Boolean, default: false },
		row: { type: Object, default: null },
		saving: { type: Boolean, default: false },
		error: { type: String, default: '' },
	},
	data() {
		return {
			price: '',
			regole: {
				positivo: v => Number(v) > 0 || 'Inserisci un prezzo maggiore di zero',
			},
		};
	},
	computed: {
		vat() {
			const v = this.row && Number(this.row.vat);
			return Number.isFinite(v) ? v : 0;
		},
		minimo() {
			if (!this.row) return null;
			return this.row.minCompetitor !== undefined && this.row.minCompetitor !== null ? this.row.minCompetitor : minCompetitor(this.row);
		},
		valido() {
			return Number(this.price) > 0;
		},
		netto() {
			return this.valido ? netPrice(Number(this.price), this.vat) : null;
		},
	},
	watch: {
		value(aperto) {
			if (!aperto || !this.row) return;
			const proposto = this.row.suggested !== null && this.row.suggested !== undefined ? this.row.suggested : this.row.price;
			this.price = proposto !== null && proposto !== undefined ? Number(proposto).toFixed(2) : '';
		},
	},
	methods: {
		money,
		conferma() {
			if (this.valido) this.$emit('confirm', round2(Number(this.price)));
		},
	},
};
</script>
